import { Moon, Sun } from "lucide-react";
import { useTheme } from "@/components/sybrax/ThemeProvider";

const ThemeToggle = ({ className = "" }) => {
    const { theme, toggleTheme } = useTheme();
    const isDark = theme === "dark";

    return (
        <button
            type="button"
            data-testid="theme-toggle"
            onClick={toggleTheme}
            aria-label={isDark ? "Switch to light theme" : "Switch to dark theme"}
            title={isDark ? "Switch to light theme" : "Switch to dark theme"}
            className={
                "relative inline-flex items-center justify-center w-10 h-10 rounded-full " +
                "border border-slate-300/70 dark:border-white/10 " +
                "bg-white/70 dark:bg-white/[0.04] " +
                "text-slate-700 dark:text-slate-200 " +
                "hover:bg-white dark:hover:bg-white/[0.08] " +
                "hover:border-cyan-500/50 dark:hover:border-cyan-400/40 " +
                "transition-all backdrop-blur-md " +
                className
            }
        >
            <Sun
                size={16}
                strokeWidth={1.8}
                className={`absolute transition-all duration-300 ${
                    isDark ? "opacity-0 -rotate-90 scale-50" : "opacity-100 rotate-0 scale-100"
                }`}
            />
            <Moon
                size={16}
                strokeWidth={1.8}
                className={`absolute transition-all duration-300 ${
                    isDark ? "opacity-100 rotate-0 scale-100" : "opacity-0 rotate-90 scale-50"
                }`}
            />
        </button>
    );
};

export default ThemeToggle;
